import { BDropdownItem, BDropdown } from 'bootstrap-vue-next';

export default{
    registerComponents: function(app) {
        // register global components
        app.component('home-dashboard', require('./components/HomeDashboard.vue').default)
        app.component('code-editor', require('./components/CodeEditor.vue').default)
        app.component('translation-editor', require('./components/TranslationEditor.vue').default)
        app.component('translation-importer', require('./components/TranslationImporter.vue').default)
        app.component('translation-exporter', require('./components/TranslationExporter.vue').default)
        app.component('translation-asset-manager', require('./components/TranslationAssetManager.vue').default)
        app.component('translation-sync-keys', require('./components/TranslationSyncKeys.vue').default)
        // app.component('code-editor-advanced', require('./components/CodeEditorAdvanced.vue').default)
        app.component('membership', require('./components/Membership.vue').default)
        app.component('toggle-favorite', require('./components/ToggleFavorite.vue').default)
        app.component('asset-manager-modal', require('./components/AssetManagerModal.vue').default)
        app.component('asset-manager', require('./components/AssetManager.vue').default)
        app.component('content-builder', require('./components/ContentBuilder.vue').default)
        app.component('screen-template-builder', require('./components/ScreenTemplateBuilder.vue').default)
        app.component('theme-editor', require('./components/ThemeEditor.vue').default)
        app.component('project-dashboard', require('./components/ProjectDashboard.vue').default)
        app.component('publishing-dashboard', require('./components/PublishingDashboard.vue').default)
        app.component('publishing-create', require('./components/PublicationCreate.vue').default)
        app.component('publishing-ai-generate', require('./components/PublicationAiGenerate.vue').default)
        app.component('ai-relay', require('./components/AiRelay.vue').default)
        app.component('ai-relay-history', require('./components/AiRelayHistory.vue').default)
        app.component('ai-help-modal', require('./components/AiHelpModal.vue').default)
        app.component('ai-sources-file-upload', require('./components/AiSourcesFileUpload.vue').default)

        app.component('publishing-settings', require('./components/PublicationSettings.vue').default)
        app.component('bulk-process-selection', require('./components/BulkProcessSelection.vue').default)
        app.component('driver-dashboard', require('./components/DriverDashboard.vue').default)
        app.component('driver-new-version-upload', require('./components/DriverNewVersionUpload.vue').default)
        app.component('clone-process-dashboard', require('./components/CloneProcessDashboard.vue').default)
        app.component('toast-master', require('./components/ToastMaster.vue').default)
        app.component('admin-console', require('./components/AdminConsole.vue').default)
        app.component('driver-sync', require('./components/DriverSync.vue').default)

        // register UI components
        app.component('app-button', require('./components/AppButton.vue').default)
        app.component('app-error', require('./components/AppError.vue').default)
        app.component('app-table', require('./components/AppTable.vue').default)
        app.component('app-list-item-group', require('./components/AppListItemGroup.vue').default)
        app.component('app-paginator', require('./components/AppPaginator.vue').default)
        app.component('app-loader', require('./components/AppLoader.vue').default)
        app.component('app-loader-fill', require('./components/AppLoaderFill.vue').default)
        app.component('app-select', require('./components/AppSelect.vue').default)
        // app.component('app-choices', require('./components/AppChoices.vue').default)
        app.component('svg-icon', require('./components/SVGIcon.vue').default)

        // register bootstrap-vue components
        app.component('b-dropdown-item', BDropdownItem)
        app.component('b-dropdown', BDropdown)

        return Object(app._context.components)
    }
}
